/**
 * A UUID generation utility.
 */
export class UUIDUtils {
    /**
     * Generates a new UUID.
     */
    public static generate(): string {
        return ('' + [1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (ch) => {
            const c = Number(ch);
            return (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16);
        });
    }
}
